import { SystemBase2 } from "@inter-ikea-core/core-toolbox";
import LeftSideAttachedToComponent from "../components/LeftSideAttachedToComponent";
import RightSideAttachedToComponent from "../components/RightSideAttachedToComponent";
import { LEFT, RIGHT } from "../constants";
import { entityIsSection } from "../functions/attachedTo";
import { handleAttachment, handleDetachment, } from "../functions/sectionAttachment";
export class HandleSectionAttachmentSystem extends SystemBase2 {
    constructor(productManager) {
        super(LeftSideAttachedToComponent.id, RightSideAttachedToComponent.id);
        this.productManager = productManager;
        this.doingChangesOnComponent = [];
        this.id = "HandleSectionAttachmentSystem";
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
    }
    onAddComponent(_entity, _newComponent) {
        entityIsSection(_entity) && handleAttachment(_entity, RIGHT);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        entityIsSection(_entity) && handleAttachment(_entity, RIGHT);
    }
    onRemoveComponent(_entity, _oldComponent) {
        entityIsSection(_entity) && handleDetachment(_entity, RIGHT);
    }
    onAddComponent2(_entity, _newComponent) {
        entityIsSection(_entity) && handleAttachment(_entity, LEFT);
    }
    onUpdateComponent2(_entity, _oldComponent, _newComponent) {
        entityIsSection(_entity) && handleAttachment(_entity, LEFT);
    }
    onRemoveComponent2(_entity, _oldComponent) {
        entityIsSection(_entity) && handleDetachment(_entity, LEFT);
    }
}
